import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: e = 16, useVw: l, useRem: o, color: n, withColor: c, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const h = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-xianhuojiaoyi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "24px-ç°è´§äº¤æ"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? r(n, 0, "#262933") : "#262933",
        datafollowfill: c ? r(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M3.56 12a8.44 8.44 0 1 1 16.88 0 .8.8 0 1 0 1.6 0c0-5.545-4.495-10.04-10.04-10.04C6.455 1.96 1.96 6.455 1.96 12c0 5.545 4.495 10.04 10.04 10.04a.8.8 0 0 0 0-1.6A8.44 8.44 0 0 1 3.56 12Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M13.864 8.309a.8.8 0 0 0-1.503-.547l-.121.331-1.083-.394a1.153 1.153 0 0 0-1.478.689l-.59 1.624h-.003L7.947 13.14c-.217.598.091 1.26.69 1.477l1.082.395-.12.331a.8.8 0 1 0 1.503.547l.121-.331.602.219a2.24 2.24 0 0 0 2.873-2.87 2.24 2.24 0 0 0-.352-4.048l-.602-.22.12-.331Zm-.506 3.258.011.003a.64.64 0 0 0 .43-1.207L11.03 9.355l-.438 1.205 2.766 1.006Zm-3.754 1.7.438-1.205 2.77 1.009.008.003a.64.64 0 0 1-.448 1.2l-2.768-1.007Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M19.074 14.5a.75.75 0 0 1 1.06.05l1.66 1.82a.75.75 0 0 1-.554 1.255H15.3a.75.75 0 0 1 0-1.5h4.24l-.515-.565a.75.75 0 0 1 .05-1.06Zm-1.636 7.276a.75.75 0 0 1-1.06-.056l-1.636-1.82a.75.75 0 0 1 .558-1.252h5.914a.75.75 0 0 1 0 1.5h-4.231l.511.569a.75.75 0 0 1-.056 1.059Z"
        }
      )
    )
  )));
}, u = f;
export {
  u as default
};
